import { ForgeRadio } from '@tylertech/forge-react';
import React, { FormEvent, FunctionComponent } from 'react';
import { fetchTranslation } from 'common/locale';
import { isEmpty } from 'lodash';

export interface FilterRadioButtonProps {
  selectedFiltered: boolean;
  handleRadioFilterChange: (selectedFiltered: boolean) => void;
  showFilteredDataOption: boolean;
  rowCountFiltered?: number;
  rowCountAll?: number;
  odata?: boolean;
}

const t = (k: string) => fetchTranslation(k, 'shared.explore_grid.export_dataset_modal');
const translationWithOption = (k: string, option: any) =>
  fetchTranslation(k, 'shared.explore_grid.export_dataset_modal', undefined, option);

const FilteringRadioButtons: FunctionComponent<FilterRadioButtonProps> = ({
  selectedFiltered,
  rowCountFiltered,
  rowCountAll,
  odata = false,
  showFilteredDataOption,
  handleRadioFilterChange,
}) => {
  const onHandleRadioFilterChange = (event: FormEvent) => {
    const target = event.target as HTMLInputElement;
    const isSelectedFiltered = target.value !== 'all';
    handleRadioFilterChange(isSelectedFiltered);
  };

  return (
    <div
      className="filtered-radio-group"
      data-testid="radio-group-filtering"
      role="radiogroup"
      aria-label={t('dialog_radio')}
    >
      {showFilteredDataOption && !odata && (
        <ForgeRadio
          className="filtered-data"
          id="radio-filtered"
          name="radio-filters"
          data-testid="radio-option-filtered"
          value="filtered"
          onClick={onHandleRadioFilterChange}
          checked={selectedFiltered}
        >
          {isEmpty(window.STORY_DATA)
            ? translationWithOption('modified_data', { rowCount: rowCountFiltered })
            : translationWithOption('filtered_data', { rowCount: rowCountFiltered })}
        </ForgeRadio>
      )}
      <ForgeRadio
        className="all-data"
        id="radio-all"
        name="radio-filters"
        data-testid="radio-option-all"
        value="all"
        onClick={onHandleRadioFilterChange}
        checked={!selectedFiltered}
      >
        {translationWithOption('all_data', { rowCount: rowCountAll })}
      </ForgeRadio>
    </div>
  );
};

export default FilteringRadioButtons;
